import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/BreadcrumbFilters"

//i18n
import { withTranslation } from "react-i18next"

//redux
import { useDispatch, useSelector } from "react-redux"
import { getBrands as onList } from "store/actions"
import TableContainerServerSide from "../../../components/Common/TableContainerServerSide"

//Custom CSS
import "./custom.scss"
import { Link } from "react-router-dom"
import { isEmpty } from "lodash"
import { Role, authorize } from "helpers/authorize"
import img_empty from "./../../../assets/images/jobs.png"

const Brands = props => {
  //meta title
  document.title = props.t("Brands")
  const IMAGE_BASE = process.env.REACT_APP_IMAGE_BASE

  const dispatch = useDispatch()
  const { error, data, tableOptions, loading } = useSelector(state => ({
    error: state.Brands?.error,
    data: state.Brands?.data || [],
    tableOptions: state.Brands?.tableOptions || null,
    loading: state.Brands?.loading || false,
  }))

  const breadcrumbItems = []

  const [tableSetting, setTableSetting] = useState({
    orderBy: "createdAt",
    ascDesc: -1,
    limit: 100,
    page: 0,
    select: "name description",
    search: "",
  })

  useEffect(() => {
    dispatch(onList(tableSetting))
  }, [tableSetting])

  const columns = useMemo(
    () => [
      {
        Header: props.t("Image"),
        accessor: "image",
        search: false, 
        Cell: ({ value }) => (
          <img
            src={value ? IMAGE_BASE + value : img_empty}
            alt="Brand"
            className="img-fluid"
            style={{ width: "100px", height: "100px", objectFit: "contain" }}
          />
        ),
      },
      {
        Header: props.t("BrandName"),
        accessor: "name",
        search: false,
      },
      {
        Header: props.t("Description"),
        accessor: "description",
        search: false,
        Cell: ({ value }) => <span>{value || "-"}</span>,
      },
      {
        Header: "",
        accessor: "_id",
        search: false,
        Cell: ({ value }) => (
          <div>
            {authorize([Role.DevMaster]) ? (
              <Link
                to={`/v1/brands/edit/${value}`}
                className="btn btn-sm btn-warning text-white me-2"
              >
                {props.t("Edit")}
              </Link>
            ) : null}
          </div>
        ),
      },
    ],
    [props.t]
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            breadcrumbItems={breadcrumbItems}
            isAdd={authorize([Role.DevMaster])}
            addTitle={props.t("Create Brand")}
            addHandle={() => {
              props.history.push("/v1/brands/create")
            }}
            className={"mb-0 pb-0"}
          />

          <TableContainerServerSide
            loading={loading}
            columns={columns}
            data={data}
            isGlobalFilter={true}
            isAddOptions={false}
            tableSetting={tableSetting}
            customPageSize={tableSetting.limit}
            className="custom-header-css"
            totalCount={tableOptions?.productTotal || 0}
            queryPageIndex={tableSetting.page}
            queryPageSize={tableSetting.limit}
            tableOptions={tableOptions}
            action={(pageIndex, pageSize, search) => {
              setTableSetting({
                orderBy: "createdAt",
                ascDesc: -1,
                limit: pageSize,
                page: pageIndex,
                select: tableSetting.select,
                search: search,
              })
            }}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

Brands.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
}

export default withTranslation()(Brands)
